export var EnumIframeMessageTypes;
(function (EnumIframeMessageTypes) {
  EnumIframeMessageTypes["PASS_GAME_DATA"] = "PASS_GAME_DATA";
  EnumIframeMessageTypes["REWARD_CALLBACK"] = "REWARD_CALLBACK";
  EnumIframeMessageTypes["INTERSTITIAL_CALLBACK"] = "INTERSTITIAL_CALLBACK";
  EnumIframeMessageTypes["CHECK_TO_STOP_MOBILE_CRAWLING"] = "CHECK_TO_STOP_MOBILE_CRAWLING";
  EnumIframeMessageTypes["ANALYTICS_GAME_DOWNLOAD"] = "ANALYTICS_GAME_DOWNLOAD";
  EnumIframeMessageTypes["RESIZE_CONTAINER"] = "RESIZE_CONTAINER";
  EnumIframeMessageTypes["SET_LS_ITEM"] = "SET_LS_ITEM";
  EnumIframeMessageTypes["REMOVE_LS_ITEM"] = "REMOVE_LS_ITEM";
  EnumIframeMessageTypes["UPDATE_COOKIE"] = "UPDATE_COOKIE";
  EnumIframeMessageTypes["UPDATE_INDEXED_DB"] = "UPDATE_INDEXED_DB";
  EnumIframeMessageTypes["UPDATE_LOCAL_STORAGE_ITEM"] = "UPDATE_LOCAL_STORAGE_ITEM";
  EnumIframeMessageTypes["LOGIN_USER"] = "LOGIN_USER";
  EnumIframeMessageTypes["LOGOUT_USER"] = "LOGOUT_USER";
  EnumIframeMessageTypes["SET_AUTHORIZED_STATUS"] = "SET_AUTHORIZED_STATUS";
  EnumIframeMessageTypes["OPEN_LOGIN_POPUP"] = "OPEN_LOGIN_POPUP";
  EnumIframeMessageTypes["CLOSE_LOGIN_POPUP"] = "CLOSE_LOGIN_POPUP";
  EnumIframeMessageTypes["ARENA_TO_GAME_ACTION"] = "ARENA_TO_GAME_ACTION";
  // GAME EVENTS
  EnumIframeMessageTypes["TEST_READY"] = "TEST_READY";
  EnumIframeMessageTypes["GAME_START"] = "GAME_START";
  EnumIframeMessageTypes["UPDATE_LOCAL_STORAGE"] = "UPDATE_LOCAL_STORAGE";
  EnumIframeMessageTypes["EVENT_CHANGE"] = "EVENT_CHANGE";
  EnumIframeMessageTypes["AD_START"] = "AD_START";
  EnumIframeMessageTypes["CHANGE_SCORE"] = "CHANGE_SCORE";
  EnumIframeMessageTypes["GAME_END"] = "GAME_END";
  EnumIframeMessageTypes["REWARD_START"] = "REWARD_START";
  EnumIframeMessageTypes["INTERSTITIAL_START"] = "INTERSTITIAL_START";
  EnumIframeMessageTypes["GAME_PAUSE"] = "GAME_PAUSE";
  EnumIframeMessageTypes["GAME_RESUME"] = "GAME_RESUME";
  EnumIframeMessageTypes["AD_REFRESH"] = "AD_REFRESH";
  EnumIframeMessageTypes["PURCHASE_UPDATE"] = "PURCHASE_UPDATE";
  EnumIframeMessageTypes["PURCHASE_REQUEST"] = "PURCHASE_REQUEST";
  EnumIframeMessageTypes["PURCHASE_RESPONSE"] = "PURCHASE_RESPONSE";
  // ARKCOM SPECIFIC
  EnumIframeMessageTypes["AB_TEST_GROUP"] = "AB_TEST_GROUP";
  EnumIframeMessageTypes["USER_EVENT"] = "USER_EVENT";
  EnumIframeMessageTypes["MARKETING_ACTION"] = "MARKETING_ACTION";
  EnumIframeMessageTypes["ANALYTICS_EVENT"] = "ANALYTICS_EVENT";
  EnumIframeMessageTypes["AUTH_API_EVENT"] = "AUTH_API_EVENT";
  //AARP SPECIFIC
  EnumIframeMessageTypes["OPT_LOG_IN"] = "OPT_LOG_IN";
  EnumIframeMessageTypes["REDEEM_POWERUP"] = "REDEEM_POWERUP";
  EnumIframeMessageTypes["POWERUP_CALLBACK"] = "POWERUP_CALLBACK";
})(EnumIframeMessageTypes || (EnumIframeMessageTypes = {}));